export class BreadcrumbText {
  static Landing = 'Pasta Service';
}

export class UIPath {
  static Landing = '/';
  static PrepareDish = '/workshop/prepare';
  static ReadyDishes = '/workshop/pass';
}
